// extracted by mini-css-extract-plugin
export default {"tab":"CardWithTabs_tab__wH6uH"};